import { Stack, Typography } from '@mui/material'
import { memo } from 'react'
import theme from 'src/theme/theme'

import Logo from 'src/assets/svg/logo-full.svg'
import Link from 'next/link'
import { NewReleases } from '@mui/icons-material'

export default memo(function BrandBg() {
  return (
    <Stack
      id="left"
      height={'100%'}
      alignItems="center"
      justifyContent="center"
      flex={1.5}
      bgcolor={theme.palette.primary.main}
      sx={{ '@media (max-width: 1024px)': { display: 'none' } }}
    >
      <Stack gap={2} alignItems="center" p={2} justifyContent="center" color={theme.palette.primary.contrastText} maxWidth={'40rem'}>
        <Logo style={{ height: '5rem', marginBottom: '2rem' }} />
        <Typography variant="h4" fontWeight={900}>
          Rewrite The Rulebook of Streaming with Our OTT Platform
        </Typography>
        <Typography fontSize={'1.2rem'}>
          Transform the way viewers consume content. Scalable, customizable, and secure OTT platform to deliver a hassle-free video experience. Take
          your audience on a seamless streaming journey.
        </Typography>
      </Stack>
      <Stack direction={'row'} alignItems="center" gap={1} position={'absolute'} bottom={20} color={theme.palette.primary.contrastText}>
        <NewReleases color="inherit" fontSize="small" />
        <Link href="/changelog" style={{ color: theme.palette.primary.contrastText, fontWeight: 800 }}>
          {`What's New`}
        </Link>
      </Stack>
    </Stack>
  )
})
